import { ECPointAttribute, UInt160Attribute, UInt256Attribute } from '@neo-one/node-core';
import { BufferStackItem } from './BufferStackItem';
import { ECPointStackItem } from './ECPointStackItem';
import { EquatableKeyStackItem } from './EquatableKeyStackItem';
import { UInt160StackItem } from './UInt160StackItem';
import { UInt256StackItem } from './UInt256StackItem';
export class AttributeStackItem extends EquatableKeyStackItem {
    asAttribute() {
        return this.value;
    }
    asUInt160() {
        return this.toValueStackItem().asUInt160();
    }
    asUInt256() {
        return this.toValueStackItem().asUInt256();
    }
    asECPoint() {
        return this.toValueStackItem().asECPoint();
    }
    asBuffer() {
        return this.toValueStackItem().asBuffer();
    }
    toValueStackItem() {
        const { value } = this;
        if (value instanceof ECPointAttribute) {
            return new ECPointStackItem(value.value);
        }
        if (value instanceof UInt160Attribute) {
            return new UInt160StackItem(value.value);
        }
        if (value instanceof UInt256Attribute) {
            return new UInt256StackItem(value.value);
        }
        return new BufferStackItem(value.value);
    }
    toContractParameter(_seen = new Set()) {
        return this.toValueStackItem().toContractParameter();
    }
    asAttributeStackItem() {
        return this;
    }
}

//# sourceMappingURL=AttributeStackItem.js.map
